export enum eDepositorType {
  Person = 'Person',
  Signatory = 'Signatory',
}
